require('./js/angular-daterangepicker.js');
module.exports = 'daterangepicker'



//////////////////
// WEBPACK FOOTER
// ./~/angular-daterangepicker/index.js
// module id = 563
// module chunks = 1